<div>
    @switch (field.inputType) {
        @case ('range') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class full-width" [formGroup]="group">
                        <label style="display: inline-block" class="dynaInputRangeLabel">{{ field.label }}:</label>
                        <!-- @if (field.showValue) {
                            <span style="margin-right: 10px;">{{slideValue}}</span>
                        } -->
                        <mat-slider discrete disableRipple color="accent" class="dynamic-input" [max]="field.max" [min]="field.min"
                                    [step]="field.step">
                            <input matSliderThumb (change)="updateSlider($event.target)" [formControlName]="field.name" />
                        </mat-slider>
                        @for (validation of field.validations; track validation) {
                            <ng-container ngProjectAs="mat-error">
                                @if (group.get(field.name).hasError(validation.name)) {
                                    <mat-error>{{ validation.message }}</mat-error>
                                }
                            </ng-container>
                        }
                    </span>
                }
            </div>
        }
        @case ('color') {
            <div>
                @if (field.hideMe != true) {
                    <div class="full-width {{field.name}}-dynamic-class" [formGroup]="group" style="margin: auto;">
                        <label style="display: inline-block; position: relative; left: -5px; top: -10px"
                               class="dynaInputKnobLabel">{{ field.label }}</label>
                        <input type="text" spellcheck="false" autocomplete="off" #ignoredInput class="colorBox"
                               (click)="colorToggle=!colorToggle" [style.background]="group.get(field.name).value"
                               [style.color]="group.get(field.name).value"
                               [formControlName]="field.name" (colorPickerChange)="onColorChanged($event)"
                               [cpPosition]="'bottom'"
                               [readonly]="true"
                               [cpIgnoredElements]="[ignoredInput]" [(cpToggle)]="colorToggle"
                               [(colorPicker)]="group.get(field.name).value" />
                        <br />
                        <br />
                    </div>
                }
            </div>
        }
        @case ('knob') {
            <div>
                <div class="full-width" [formGroup]="group" style="margin: auto;">
                    <label style="display: inline-block"
                           class="dynaInputKnobLabel {{field.name}}-dynamic-class">{{ field.label }}</label>
                    <app-rotator [min]="field.min" [max]="field.max" [formControlName]="field.name" [value]="field.value">
                    </app-rotator>
                </div>
            </div>
        }
        @case ('label') {
            <div style="padding-left: 45px" class="{{field.name}}-dynamic-class">
                @if (field.hideMe != true) {
                    <div>
              <span class="full-width" fxLayout="column" fxLayoutAlign="start start"
                    [style.display]="hideMe ? 'none' : 'flex'">
                <br />
                  @if (field.value) {
                      <small style="font-size: 0.7em; opacity: 0.7">{{ field.value }}</small>
                  }
                  <label style="display: inline-block">{{ field.label }}</label>
                <br />
              </span>
                    </div>
                }
            </div>
        }
        @case ('tablelist') {
            <div>
          <span [style.display]="hideMe ? 'none' : 'block'" class="{{field.name}}-dynamic-class">
            <form [formGroup]="group" floatLabel="never">
              <app-table-list-input #tableList matInput required
                                    (update)="onTableListUpdate($event)"
                                    [keepTableIds]="field.keepTableIds"
                                    [cloneVals]="field.cloneVals"
                                    [disableDrag]="field.disableDrag"
                                    [confirmRemove]="field.confirmRemove"
                                    [buttons]="field.buttons"
                                    [tableColumns]="field.tableColumns"
                                    [callBackEvent]="field?.callBackEvent"
                                    [callBackValue]="field.callBackValue"
                                    [callBackFaIcon]="field.callBackFaIcon"
                                    [buttonBarClassName]="field.buttonBarClassName"
                                    [multiSelect]="field.multiSelect"
                                    [inputEditFormat]="field.inputEditFormat"
                                    [requiredFields]="field.requiredFields"
                                    [rememberSelection]="field.rememberSelection"
                                    [inputEditRenamePath]="field.inputEditRenamePath"
                                    [formControlName]="field.name"
                                    [allowFilter]="field.allowFilter"
                                    [expandableEditor]="field.expandableEditor"
                                    [enablePagination]="field.enablePagination"
                                    [allowTableOnDialog]="field.allowTableOnDialog"
                                    [disableSubmit]="field.disableSubmit">
              </app-table-list-input>
            </form>
          </span>
            </div>
        }
        @case ('textarea') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
              <span [style.display]="hideMe ? 'none' : ''" class="textarea-wrapper">
                <div class="textarea-icons">
                  <button mat-icon-button type="button" (click)="selectAllTextarea()"
                          matTooltip="select all text" [matTooltipShowDelay]="500"
                          class="textarea-icon-btn">
                    <mat-icon>edit_square</mat-icon>
                  </button>
                  <button mat-icon-button type="button" (click)="clearTextarea()"
                          matTooltip="clear text" [matTooltipShowDelay]="500"
                          class="textarea-icon-btn">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
                <mat-form-field class="full-width textarea" [formGroup]="group">
                  <mat-label>{{ field.label }}</mat-label>
                  <textarea #textareaRef [inputrestriction]="field?.restrictChar" class="dynamic-input" matInput spellcheck="true"
                            [formControlName]="field.name" [placeholder]=""
                            [type]="field.inputType" rows="3">
                  </textarea>
                    @for (validation of field.validations; track validation) {
                        <ng-container ngProjectAs="mat-error">
                      @if (group.get(field.name).hasError(validation.name)) {
                          <mat-error>{{ validation.message }}
                        </mat-error>
                      }
                    </ng-container>
                    }
                </mat-form-field>
              </span>
            </span>
                }
            </div>
        }
        @case ('time') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
              <mat-form-field class="full-width" [formGroup]="group">
                <mat-label>{{ field.label }}</mat-label>
                <input class="dynamic-input" matInput min="0" [formControlName]="field.name" autocomplete="off"
                       [value]="field.value" step="1" type="time" />
                  <!-- remove AM / PM uncomment next line -->
                  <!-- <input class="dynamic-input without_ampm" matInput [formControlName]="field.name" [value]="field.value" step="1" [placeholder]="field.label" type="time"> -->
                  @for (validation of field.validations; track validation) {
                      <ng-container ngProjectAs="mat-error">
                      @if (group.get(field.name).hasError(validation.name)) {
                          <mat-error>{{ validation.message }}
                        </mat-error>
                      }
                    </ng-container>
                  }
                </mat-form-field>
              </span>
                }
            </div>
        }
        @case ('time_stepper') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
                <span [style.display]="hideMe ? 'none' : ''">
                  <mat-form-field class="full-width" [formGroup]="group">
                    <app-input-time class="dynamic-input" matInput [formControlName]="field.name" autocomplete="off"
                                    [value]="field.value"></app-input-time>
                    <mat-icon style="position: relative; left: 16px; top: -5px" matSuffix>schedule</mat-icon>
                    <mat-hint>{{ field.label }}</mat-hint>
                      @for (validation of field.validations; track validation) {
                          <ng-container ngProjectAs="mat-error">
                        @if (group.get(field.name).hasError(validation.name)) {
                            <mat-error>{{ validation.message }}
                          </mat-error>
                        }
                      </ng-container>
                      }
                  </mat-form-field>
                </span>
              </span>
                }
            </div>
        }
        @case ('date') {
            <div>
                @if (field.hideMe != true) {
                    <mat-form-field class="full-width {{field.name}}-dynamic-class"
                                    [style.display]="hideMe ? 'none' : ''" [formGroup]="group">
                        <input inputrestriction="numbers" matInput autocomplete="off" [formControlName]="field.name"
                               [value]="field.value"
                               [matDatepicker]="myDatepicker" />
                        @for (validation of field.validations; track validation) {
                            <ng-container ngProjectAs="mat-error">
                                @if (group.get(field.name).hasError(validation.name)) {
                                    <mat-error>{{ validation.message }}</mat-error>
                                }
                            </ng-container>
                        }
                        <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #myDatepicker></mat-datepicker>
                    </mat-form-field>
                }
            </div>
        }
        @case ('number') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class-{{field.hideMe}}">
                  <mat-form-field class="full-width" [formGroup]="group">
                    <mat-label>{{ field.label }}</mat-label>
                    <input inputrestriction="numbers" autocomplete="off" class="dynamic-input" matInput
                           [formControlName]="field.name"
                           (keyup)="onKeyNumeric($event)"
                           [placeholder]="" [max]="field.max" [min]="field.min" [step]="field.step"
                           [type]="field.inputType" />
                      @for (validation of field.validations; track validation) {
                          <ng-container ngProjectAs="mat-error">
                          @if (group.get(field.name).hasError(validation.name)) {
                              <mat-error>{{ validation.message }}
                            </mat-error>
                          }
                        </ng-container>
                      }
                    </mat-form-field>
                  </span>
                }
            </div>
        }
        @case ('number_rich') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class-{{field.hideMe}}" [formGroup]="group">
                        <app-drop-number-selector
                            [label]="field.label"
                            [min]="field.min !== undefined ? field.min : 1"
                            [max]="field.max !== undefined ? field.max : 999"
                            [step]="field.step !== undefined ? field.step : 1"
                            [placeholder]="field.placeholder || ''"
                            [showManualInput]="field.showManualInput !== undefined ? field.showManualInput : false"
                            [noManualEdit]="field.noManualEdit !== undefined ? field.noManualEdit : false"
                            [formControlName]="field.name"
                            [validations]="field.validations">
                        </app-drop-number-selector>
                  </span>
                }
            </div>
        }
        @case ('decimal') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class-{{field.hideMe}}">
                    <mat-form-field class="full-width" [formGroup]="group">
                      <mat-label>{{ field.label }}</mat-label>
                      <input inputrestriction="decimals" autocomplete="off" class="dynamic-input" matInput
                             [formControlName]="field.name"
                             (keyup)="onKeyNumeric($event)"
                             [placeholder]="" [max]="field.max" [min]="field.min" [step]="field.step"
                             type="number" />
                        @for (validation of field.validations; track validation) {
                            <ng-container ngProjectAs="mat-error">
                          @if (group.get(field.name).hasError(validation.name)) {
                              <mat-error>{{ validation.message }}
                            </mat-error>
                          }
                        </ng-container>
                        }
                    </mat-form-field>
                  </span>
                }
            </div>
        }
        @case ('number_blur') {
            <div [formGroup]="group">
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
                    <span class="full-width">
                      <app-dynamic-input-blur-input [formControlName]="field.name" [value]="field">
                      </app-dynamic-input-blur-input>
                        <!-- <div class="relative" *ngIf="(this.group.controls[field.name].dirty || this.group.controls[field.name].touched) && this.group.controls[field.name].invalid">
                        <mat-error>{{'general.number' | transloco}}</mat-error>
                      </div>
                      <mat-error *ngIf="group.controls[field.name].invalid">{{'placeholder.required' | transloco}}</mat-error> -->
                        <!-- <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">-->
                        <!--    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>-->
                        <!-- </ng-container>-->
                </span>
              </span>
                }
            </div>
        }
        @case ('text_autocomplete') {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
                <mat-form-field class="full-width" [formGroup]="group">
                  <mat-label>{{ field.label }}</mat-label>
                  <input matInput inputrestriction="basic0" #but [matAutocomplete]="auto" [formControlName]="field.name"
                         [type]="field.inputType" (mouseleave)="onAutoCompleteFocusLost($event)"
                         (blur)="onAutoCompleteFocusLost($event)" (keyup)="onAutoCompleteFilter($event)"
                         autocomplete="off"
                         class="dynamic-input" />
                    <a matSuffix aria-label="Clear" (click)="but.value = ''">
                      <mat-icon>close</mat-icon>
                    </a>
                    <mat-autocomplete #auto="matAutocomplete">
                      @for (option of autoCompleteFilteredOptions; track option) {
                          <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @for (validation of field.validations; track validation) {
                        <ng-container ngProjectAs="mat-error">
                        @if (group.get(field.name).hasError(validation.name)) {
                            <mat-error>{{ validation.message }}
                          </mat-error>
                        }
                      </ng-container>
                    }
                  </mat-form-field>
                        @if (field.textSideButton) {
                            <button (click)="field.textSideButton.callBackSideButton($event, field);"
                                    style="position: absolute; margin-top: 7px" mat-icon-button>
                      <mat-icon>{{ field.textSideButton.icon }}</mat-icon>
                    </button>
                        }
                </span>
                }
            </div>
        }
        <!-- catch all for type: text -->
        @default {
            <div>
                @if (field.hideMe != true) {
                    <span class="{{field.name}}-dynamic-class">
                  <span [style.display]="hideMe ? 'none' : ''">
                    <!--                <button *ngIf="field.textSideButton" (click)="field.textSideButton.callBackSideButton($event, field)" style="position: absolute; margin-top: 7px" mat-icon-button>-->
                      <!--                    <mat-icon>{{field.textSideButton.icon}}</mat-icon>-->
                      <!--                </button>-->
                  <mat-form-field [style.display]="hideMe ? 'none' : ''" class="full-width" [formGroup]="group">
                    <mat-label>{{ field.label }}</mat-label>
                    <input matInput #but inputrestriction="basic0" autocomplete="off" class="dynamic-input"
                           [formControlName]="field.name"
                           [inputrestriction]="field?.restrictChar"
                           [placeholder]="field.label" [type]="field.inputType" />
                      @for (validation of field.validations; track validation) {
                          <ng-container ngProjectAs="mat-error">
                          @if (group.get(field.name).hasError(validation.name)) {
                              <mat-error>{{ validation.message }}
                            </mat-error>
                          }
                        </ng-container>
                      }
                    </mat-form-field>
                      @if (field.textSideButton) {
                          <button (click)="field.textSideButton.callBackSideButton($event, field);"
                                  style="position: absolute; margin-top: 7px" mat-icon-button>
                        <mat-icon>{{ field.textSideButton.icon }}</mat-icon>
                      </button>
                      }
                  </span>
                </span>
                }
            </div>
        }
    }
</div>
